import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _extends from "@babel/runtime/helpers/extends";
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
export const getPrefetchSlice = (type, key) => ({
  getState
}) => {
  var _prefetching$type;
  const {
    prefetching
  } = getState();
  const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];

  // check if slice is still fresh
  if (slice && Date.now() < Number(slice.expiresAt)) {
    return slice;
  }
  return undefined;
};
export const setPrefetchSlice = (type, key, slice) => ({
  setState,
  getState
}) => {
  var _prefetching$type2, _slice$promise;
  const {
    prefetching
  } = getState();
  // avoid doing extra set if same value
  if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;

  // cheap optimisation to provide prefetched result syncronously
  slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then(maybeData => slice.data = maybeData);
  setState({
    prefetching: _extends({}, prefetching, {
      [type]: _extends({}, prefetching == null ? void 0 : prefetching[type], {
        [key]: slice
      })
    })
  });
};
export const setResourceState = (type, key, state) => ({
  setState,
  getState,
  dispatch
}) => {
  const {
    data
  } = getState();
  // every time we override a resource we kill its prefetched
  dispatch(setPrefetchSlice(type, key, undefined));
  setState({
    data: _extends({}, data, {
      [type]: _extends({}, data[type] || {}, {
        [key]: state
      })
    })
  });
};
export const getResourceState = (type, key) => ({
  getState
}) => {
  const {
    data: {
      [type]: resourceDataForType
    }
  } = getState();
  return resourceDataForType == null ? void 0 : resourceDataForType[key];
};
export const deleteResourceState = (type, key) => ({
  getState,
  setState
}) => {
  const {
    data
  } = getState();
  const {
      [type]: resourceForType
    } = data,
    remainingData = _objectWithoutPropertiesLoose(data, [type].map(_toPropertyKey));
  if (key === undefined) {
    setState({
      data: remainingData
    });
  } else if (resourceForType) {
    const remainingForType = _objectWithoutPropertiesLoose(resourceForType, [key].map(_toPropertyKey));
    setState({
      data: _extends({}, remainingData, {
        [type]: remainingForType
      })
    });
  }
};